import { inject, Pipe, PipeTransform } from '@angular/core';
import { DateFormat } from '../enums/DateFormat';
import { LocaleService } from '../services/locale.service';

const formatConfig: {
  [key: string]: Intl.DateTimeFormatOptions;
} = {
  shortTime: { hour: '2-digit', minute: '2-digit' },
  medium: { month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' },
  birthDate: { month: '2-digit', day: '2-digit', year: 'numeric' },
  short: { month: 'short', day: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' },
  mediumExact: { month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' },
  long: { month: '2-digit', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }
};

@Pipe({
  standalone: true,
  name: 'localizedDate'
})
export class LocalizedDatePipe implements PipeTransform {
  private readonly localeService: LocaleService = inject(LocaleService);

  transform(date: number | string, format: DateFormat = DateFormat.MEDIUM): string | null {
    if (date === null || date === undefined) {
      return null;
    }

    if (Number.isNaN(new Date(date).getTime())) {
      console.warn(`Invalid date provided: ${date}`);
      return null;
    }

    if (!formatConfig[format]) {
      console.warn(`Unsupported date format: ${format}`);
      return null;
    }

    return new Intl.DateTimeFormat(this.localeService.locale(), formatConfig[format]).format(new Date(date));
  }
}
